// A report's or dashboard's filter bar settings, as its quick filter and
// pinned filter settings edit them
export interface FilterBarSettings {
  // The saved filters' source its quick filters are kept under, e.g.
  // "report: <id>" (see useQuickFilters)
  quickFilterSource: string;
  quickFilters: LegacySavedFilter[];
  quickFilterOrder: string[];
  pinnedFilterFields: ReportPinnedFilters.Field[];
  save: (patch: {
    quickFilterOrder?: string[];
    pinnedFilterFields?: ReportPinnedFilters.Field[];
  }) => Promise<void>;
}

// Quick filters in their saved order. The order may reference filters that
// have since been deleted, which are left out; filters missing from it go
// at the end.
export const orderQuickFilters = ({
  quickFilters,
  quickFilterOrder,
}: {
  quickFilters: LegacySavedFilter[];
  quickFilterOrder: string[];
}): LegacySavedFilter[] => [
  ...quickFilterOrder
    .map((filterId) => quickFilters.find((f) => f.id === filterId))
    .filter((f): f is LegacySavedFilter => !!f),
  ...quickFilters.filter((f) => !quickFilterOrder.includes(f.id)),
];
